import React from 'react';
import ViewModal from '../Modals/ViewModal';
import InfoField from '../Shared/InfoField';
import { useSupplier } from '../../hooks/useSupplier';

interface CustomerViewPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const SupplierViewPopup: React.FC<CustomerViewPopupProps> = ({
  isOpen,
  onClose,
}) => {
  const { detail } = useSupplier();

  return (
    <ViewModal
      popupOpen={isOpen}
      setPopupOpen={onClose}
      title="Detalle del Proveedor"
      maxWidth="max-w-5xl"
    >
      {detail ? (
        <>
          {/* 👉 Encabezado */}
          <div className="mb-8">
            <h2 className="text-gray-800 text-2xl font-bold dark:text-white">
              {detail.name || detail.legalName || 'Sin nombre'}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 mt-1 text-sm">
              Tipo de Proveedor: {detail.entityTypeName ?? '—'}
            </p>
            <span
              className={`mt-3 inline-flex rounded-full px-3 py-1 text-sm font-medium ${
                detail.status
                  ? 'bg-green-500 text-white'
                  : 'bg-[#DC3545] text-white'
              }`}
            >
              {detail.status ? 'Activo' : 'Inactivo'}
            </span>
          </div>

          {/* 👉 Datos Generales */}
          <section className="mb-8">
            <h3 className="text-gray-700 mb-4 text-lg font-semibold dark:text-white">
              Datos Generales
            </h3>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              <InfoField label="NIT" value={detail.nit} />
              <InfoField label="NRC" value={detail.nrc} />
              <InfoField label="DUI" value={detail.dui} />
              <InfoField label="Pasaporte" value={detail.passportNumber} />
              <InfoField
                label="Carnet de Residente"
                value={detail.residentCardNumber}
              />
              <InfoField
                label="Otra Identificación"
                value={detail.otherIdentification}
              />
              <InfoField label="Razón Social" value={detail.legalName} />
              <InfoField label="Nombre Comercial" value={detail.tradeName} />
              <InfoField label="Teléfono" value={detail.phone} />
              <InfoField label="Correo" value={detail.email} />
            </div>
          </section>

          {/* Categoría de Contribuyente */}
          <section className="mb-8">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <InfoField
                label="Categoría Contribuyente"
                value={detail.taxpayerCategoryName}
              />
              <InfoField
                label="Tipo de Documento Identificación"
                value={detail.documentIdentificationTypeName}
              />
            </div>
          </section>

          {/* 👉 Actividad Económica */}
          <section className="mb-8">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <InfoField
                label="Actividad Económica"
                value={detail.economicActivityName}
              />
            </div>
          </section>

          {/* 👉 Dirección */}
          <section className="mb-8">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <InfoField label="Departamento" value={detail.departmentName} />
              <InfoField label="Municipio" value={detail.municipalityName} />
            </div>
            <div className="mt-4">
              <InfoField label="Complemento" value={detail.complement} />
            </div>
          </section>

          {/* 👉 Botón de cierre */}
          <button
            onClick={onClose}
            className="mt-8 w-full rounded-md bg-primary px-4 py-2 text-white hover:bg-opacity-90"
          >
            Cerrar
          </button>
        </>
      ) : (
        <div className="text-gray-600 dark:text-gray-300 text-center">
          <p>No hay información para mostrar por el momento.</p>
          <button
            onClick={onClose}
            className="mt-6 w-full rounded-md bg-primary px-4 py-2 text-white hover:bg-opacity-90"
          >
            Cerrar
          </button>
        </div>
      )}
    </ViewModal>
  );
};

export default SupplierViewPopup;
